module.exports = __webpack_public_path__ + "static/media/dror.d3e105c9.png";